'use client';

import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';
import { studioAIService } from '../services';

export function useReleaseNotes(canViewReleaseNotes: boolean) {
    const { data: pendingNotes, isLoading } = useQuery({
        queryKey: QUERY_KEYS.RELEASE_NOTES_PENDING,
        queryFn: () => studioAIService.getPendingReleaseNotes(),
        staleTime: 1000 * 60 * 10,
        gcTime: 1000 * 60 * 30,
        retry: 1,
        enabled: canViewReleaseNotes,
    });

    return { pendingNotes: pendingNotes ?? [], isLoading, canViewReleaseNotes };
}
